import React from "react";

import AllPos from "./PosModule/AllPos";

const Pos = () => {
  return (
    <div>
      <AllPos />
    </div>
  );
};

export default Pos;
